<template>
    <div class="kfc_wrap">
        <div class="search_bar fr ac jsb">
            <div class="location fr ac" @click="goCityList">
                <span>{{ selectedCity }}</span>
                <img
                    class="down_icon"
                    src="../../../static/imgs/kfc/down.png"
                    alt
                />
            </div>
            <div class="input_wrap fr ac">
                <img
                    class="search_icon"
                    src="../../../static/imgs/kfc/search.png"
                    alt
                />
                <input
                    type="text"
                    v-model="dinerVal"
                    placeholder="请输入餐厅名称或地址搜索"
                />
                <img
                    v-show="dinerVal"
                    @click="dinerVal = ''"
                    class="del_icon"
                    src="../../../static/imgs/kfc/del.png"
                    alt
                />
            </div>
        </div>
        <div class="content fc">
            <div class="section">
                <h3>常规餐厅</h3>
                <div class="diner_list fc">
                    <h4>附近</h4>
                    <div
                        class="item_wrap"
                        v-for="(item, index) in dinerList"
                        :key="index"
                        data-type="0"
                        @click="selectDiner(item)"
                    >
                        <div
                            class="diner_item fc jc"
                            @touchstart.capture="touchStart"
                            @touchend.capture="touchEnd"
                        >
                            <div class="fr ac jsb">
                                <span
                                    :class="
                                        selectedDiner.name == item.name
                                            ? 'diner_name selected'
                                            : 'diner_name'
                                    "
                                    >{{ item.name }} -
                                    <span class="diner_city">{{
                                        item.cityname
                                    }}</span></span
                                >
                                <span class="distance" v-show="item.distance"
                                    >{{
                                        item.distance | formatDistance
                                    }}公里</span
                                >
                            </div>
                            <p class="address">{{ item.address }}</p>
                        </div>
                        <div
                            class="favorite_btn"
                            @click.stop="switchFavorite(item.collect, item.id)"
                        >
                            {{ item.collect == "N" ? "收藏" : "已收藏" }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="section pb180">
                <h3>常去 &amp 收藏</h3>
                <div
                    v-if="favoDinerList.length && auth_code"
                    class="diner_list fc"
                >
                    <div
                        class="item_wrap"
                        v-for="(item, index) in favoDinerList"
                        :key="index"
                        data-type="0"
                        @click="selectDiner(item)"
                    >
                        <div
                            class="diner_item fc jc"
                            @touchstart.capture="touchStart"
                            @touchend.capture="touchEnd"
                        >
                            <div class="fr ac jsb">
                                <span
                                    :class="
                                        selectedDiner.name == item.name
                                            ? 'diner_name selected'
                                            : 'diner_name'
                                    "
                                    >{{ item.name }} -
                                    <span class="diner_city">{{
                                        item.cityname
                                    }}</span></span
                                >
                                <span class="distance" v-show="item.distance"
                                    >{{
                                        item.distance | formatDistance
                                    }}公里</span
                                >
                            </div>
                            <p class="address">{{ item.address }}</p>
                        </div>
                        <div
                            class="favorite_btn"
                            @click.stop="switchFavorite(item.collect, item.id)"
                        >
                            {{ item.collect == "N" ? "收藏" : "已收藏" }}
                        </div>
                    </div>
                </div>
                <div v-else class="no_data center">
                    左滑上方的餐厅列表可以收藏餐厅哦
                </div>
            </div>
        </div>
        <transition name="diner_layer">
            <div v-show="showLayer" class="dine_layer fc">
                <div class="close frr">
                    <img
                        class="close_icon"
                        @click="toggleLayer"
                        src="../../../static/imgs/kfc/del.png"
                        alt
                    />
                </div>
                <div class="layer_content fc">
                    <div class="diner_info fc">
                        <div class="fr ac">
                            <img
                                class="diner_icon"
                                src="../../../static/imgs/kfc/kfc_diner.png"
                                alt
                            />
                            <span class="diner_name">{{
                                selectedDiner.name
                            }}</span>
                        </div>
                        <p>{{ selectedDiner.address }}</p>
                    </div>
                    <div class="order_type fc">
                        <div class="type_item fr ac">
                            <img
                                class="check_icon"
                                src="../../../static/imgs/kfc/kfc-checked.png"
                                alt
                            />
                            <div class="fc">
                                <span>现在点餐 支付成功后点餐</span>
                                <span>Now</span>
                            </div>
                        </div>
                    </div>
                    <div class="dine_type fc">
                        <h3>请选择就餐方式</h3>
                        <div class="dine_items fr ac jsb">
                            <img
                                class="type_img"
                                :src="
                                    dineType == 'dineIn'
                                        ? 'https://res.dumovie.com/mall/202004/1587885691136.png'
                                        : 'https://res.dumovie.com/mall/202004/1587885729430.png'
                                "
                                alt
                                @click="orderFood('dineIn')"
                            />
                            <img
                                class="type_img"
                                src="https://res.dumovie.com/mall/202004/1587885579335.png"
                                alt
                                @click="orderFood('takeAway')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div v-show="showLayer" @click="toggleLayer" class="shade"></div>
        <!-- <kfc-tab-bar></kfc-tab-bar> -->
    </div>
</template>

<script>
import { Indicator, MessageBox, Toast } from "mint-ui";
import kfcTabBar from "../../components/common/kfcTabBar.vue";
export default {
    data() {
        return {
            selectedDiner: {},
            dinerList: [],
            dinerVal: "",
            favoDinerList: [],
            locationInfo: {},
            cityList: [],
            selectedCity: this.getLocal("selectedCity")
                ? this.getLocal("selectedCity")
                : this.getLocal("currentCity")
                ? this.getLocal("currentCity")
                : "上海",
            citycode: this.getLocal("selectedCityCode")
                ? this.getLocal("selectedCityCode")
                : this.getLocal("currentCityCode")
                ? this.getLocal("currentCityCode")
                : "310100",
            showLayer: false,
            dineType: "", //就餐方式
            auth_code: this.getLocal("auth_code")
                ? this.getLocal("auth_code")
                : "",
            openid: this.getLocal("openid") ? this.getLocal("openid") : "", //微信openid
            code: sessionStorage.getItem("code")
                ? sessionStorage.getItem("code")
                : "", //获取微信openid需要的code
        };
    },
    components: {
        kfcTabBar,
    },
    created() {
        console.log("created");
        this.getCityList();
        if (this.code && !this.openid) {
            this.getOpenId();
        }
    },
    activated() {
        this.selectedCity = this.getLocal("selectedCity")
            ? this.getLocal("selectedCity")
            : this.getLocal("currentCity")
            ? this.getLocal("currentCity")
            : "上海";
        this.citycode = this.getLocal("selectedCityCode")
            ? this.getLocal("selectedCityCode")
            : this.getLocal("currentCityCode")
            ? this.getLocal("currentCityCode")
            : "310100";
    },
    watch: {
        dinerVal: function (newVal, oldVal) {
            this.getDinerList();
        },
        citycode: function (newVal, oldVal) {
            console.log(newVal, oldVal);
            this.getDinerList();
            this.getFavoriteDiner();
        },
    },
    methods: {
        // 获取微信openid
        getOpenId() {
            this.$post({
                method: "weixin.get.openid",
                code: this.code,
            }).then((res) => {
                if (res.success) {
                    this.openid = res.data;
                    this.setLocal("openid", res.data);
                }
            });
        },
        //获取城市列表
        getCityList() {
            this.removeLocal("selectedCity");
            this.removeLocal("selectedCityCode");
            this.removeLocal("currentCity");
            this.removeLocal("currentCityCode");
            this.removeLocal("countycode");
            this.removeLocal("selectedCounty");
            this.removeLocal("locationInfo");
            this.$post({
                method: "movie.city.list",
            }).then((res) => {
                if (res.success) {
                    this.citylist = res.data.citylist;
                    try {
                        this.getLocation();
                    } catch (error) {
                        Indicator.close();
                    }
                }
            });
        },
        // 定位
        getLocation() {
            Indicator.open("定位中...");
            let _this = this;
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    // 是否使用高精度定位，默认：true
                    enableHighAccuracy: true,
                    // 设置定位超时时间，默认：无穷大
                    timeout: 5000,
                });
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, "complete", onComplete);
                AMap.event.addListener(geolocation, "error", onError);
                // data是具体的定位信息
                function onComplete(data) {
                    Indicator.close();
                    console.log("具体的定位信息", data);
                    _this.locationInfo = data.position;
                    _this.setLocal("locationInfo", data.position);
                    _this.matchCityCode(data.formattedAddress);
                }
                function onError(data) {
                    // 失败 启用 ip定位
                    let errTxt = JSON.stringify(data);
                    console.log("errTxt", errTxt);
                    Toast({
                        message: "定位失败，可以搜索门店关键字进行查找",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                    Indicator.close();
                    AMap.plugin("AMap.CitySearch", function () {
                        var citySearch = new AMap.CitySearch();
                        citySearch.getLocalCity(function (status, result) {
                            if (status === "complete" && result.info === "OK") {
                                // 查询成功，result即为当前所在城市信息
                                console.log("通过ip获取当前城市：", result);
                                _this.matchCityCode(result.city);
                            }
                        });
                    });
                }
            });
        },
        matchCityCode(txt) {
            for (let i of this.citylist) {
                if (txt.indexOf(i.name) >= 0) {
                    console.log(i.citycode);
                    this.selectedCity = i.name;
                    this.citycode = i.citycode;
                    this.setLocal("currentCity", i.name);
                    this.setLocal("currentCityCode", i.citycode);
                    break;
                }
            }
            if (!this.getLocal("currentCity")) {
                MessageBox.confirm("定位失败，是否手动选择城市?")
                    .then((action) => {
                        if (action == "confirm") {
                            this.$router.push("/cityList");
                        }
                    })
                    .catch((err) => {});
            } else {
                this.getDinerList();
                if (this.auth_code) {
                    this.getFavoriteDiner();
                }
            }
        },
        // 城市列表
        goCityList() {
            this.$router.push("/cityList");
        },
        getDinerList() {
            this.$post({
                method: "kfc.venue.list",
                citycode: this.citycode,
                latitude: this.locationInfo.lat ? this.locationInfo.lat : "",
                longitude: this.locationInfo.lng ? this.locationInfo.lng : "",
                searchvalue: this.dinerVal,
                auth_code: this.getLocal("auth_code"),
            }).then((res) => {
                if (res.success) {
                    this.dinerList = res.data.kfclist.slice(0, 5);
                }
            });
        },

        getFavoriteDiner() {
            this.$post({
                method: "kfc.venue.collect.list",
                citycode: this.citycode,
                latitude: this.locationInfo.lat ? this.locationInfo.lat : "",
                longitude: this.locationInfo.lng ? this.locationInfo.lng : "",
                auth_code: this.getLocal("auth_code"),
            }).then((res) => {
                if (res.success) {
                    this.favoDinerList = res.data.kfclist;
                }
            });
        },

        //滑动开始
        touchStart(e) {
            // 记录初始位置
            this.startX = e.touches[0].clientX;
        },
        //滑动结束
        touchEnd(e) {
            // 当前滑动的父级元素
            let parentElement = e.currentTarget.parentElement;
            // 记录结束位置
            this.endX = e.changedTouches[0].clientX;
            // 左滑
            if (
                parentElement.dataset.type == 0 &&
                this.startX - this.endX > 30
            ) {
                this.restSlide();
                parentElement.dataset.type = 1;
            }
            // 右滑
            if (
                parentElement.dataset.type == 1 &&
                this.startX - this.endX < -30
            ) {
                this.restSlide();
                parentElement.dataset.type = 0;
            }
            this.startX = 0;
            this.endX = 0;
        },
        //复位滑动状态
        restSlide() {
            let listItems = document.querySelectorAll(".item_wrap");
            // 复位
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].dataset.type = 0;
            }
        },
        switchFavorite(collect, id) {
            switch (collect) {
                case "N":
                    this.addFavorite(id);
                    break;
                case "Y":
                    this.delFavorite(id);
                    break;
            }
        },
        addFavorite(id) {
            if (!this.auth_code) {
                Toast({
                    message: "请先登录！",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                this.$router.push({
                    path: "/logup",
                    query: { redirect: "/kfcIndex", isKfc: true },
                });
                return;
            }
            this.$post({
                method: "kfc.venue.collect.add",
                auth_code: this.getLocal("auth_code"),
                venueid: id,
            }).then((res) => {
                if (res.success) {
                    this.getDinerList();
                    this.getFavoriteDiner();
                    this.restSlide();
                    Toast({
                        message: "收藏成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
        },
        delFavorite(id) {
            if (!this.auth_code) {
                Toast({
                    message: "请先登录！",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
                this.$router.push({
                    path: "/logup",
                    query: { redirect: "/kfcIndex", isKfc: true },
                });
                return;
            }
            this.$post({
                method: "kfc.venue.collect.del",
                auth_code: this.getLocal("auth_code"),
                venueid: id,
            }).then((res) => {
                if (res.success) {
                    this.getDinerList();
                    this.getFavoriteDiner();
                    this.restSlide();
                    Toast({
                        message: "取消收藏成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
        },
        selectDiner(item) {
            // 微信环境需要openid
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
            if (isWeixin && !this.openid) {
                let domain =
                    window.location.protocol + "//" + window.location.host; // 域名
                const url = encodeURI(
                    domain + "/duwap/static/getCode/getCode.html?usertype=kfc"
                );
                // const url = encodeURI(
                //     "https://wap.dumovie.com/duwap/static/getCode/getCode.html"
                // );
                window.location.href = url;
                return;
            }
            this.selectedDiner = item;
            this.setLocal("selectedDiner", item);
            this.orderFood("dineIn");
        },
        toggleLayer() {
            this.showLayer = !this.showLayer;
        },
        orderFood(type) {
            this.dineType = type;
            this.setLocal("dineType", type);
            let disttype = this.$route.query.disttype;
            this.$router.push({
                path: "/kfcMenu",
                query: { disttype: disttype },
            });
            // MessageBox.confirm(
            //     "点餐为第三方提供的代下单服务，取餐码收取可能会有延迟。您支付后，请凭取餐码等候门店屏幕显示即可取餐。如有疑问请联系客服。"
            // )
            //     .then((action) => {
            //         if (action == "confirm") {
            //             let disttype = this.$route.query.disttype;
            //             this.$router.push({
            //                 path: "/kfcMenu",
            //                 query: { disttype: disttype },
            //             });
            //         }
            //     })
            //     .catch((err) => {
            //         this.dineType = "";
            //         console.log(err);
            //     });
        },
    },
};
</script>
<style lang="scss">
.kfc_wrap {
    .search_bar {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        background: #fff;
        height: 100px;
        font-size: 28px;
        .location {
            .down_icon {
                width: 50px;
                height: 50px;
            }
        }
        .input_wrap {
            width: 70%;
            height: 60px;
            padding: 0 20px;
            border-radius: 30px;
            border: 1px solid #dededf;
            .search_icon {
                width: 50px;
                height: 50px;
            }
            input {
                // width: 600px;
                width: calc(100% - 50px);
                padding: 0 10px;
                box-sizing: border-box;
            }
            .del_icon {
                width: 30px;
                height: 30px;
            }
        }
    }
    .content {
        .section {
            width: 100%;
            padding-right: 30px;
            padding-left: 30px;
            box-sizing: border-box;
            h3 {
                font-size: 36px;
                height: 120px;
                line-height: 120px;
            }
            .diner_list {
                background: #fff;
                border-radius: 10px;
                overflow: hidden;
                h4 {
                    width: 100%;
                    padding: 0 30px;
                    box-sizing: border-box;
                    height: 60px;
                    line-height: 60px;
                    font-size: 26px;
                    color: #999;
                    margin-top: 10px;
                }
                .item_wrap {
                    position: relative;
                    -webkit-transition: all 0.2s;
                    transition: all 0.2s;
                    .diner_item {
                        width: 100%;
                        height: 120px;
                        padding: 0 30px;
                        box-sizing: border-box;
                        .diner_name {
                            font-size: 28px;
                        }
                        .selected {
                            color: #d62f35;
                        }
                        .diner_city {
                            // color: #999;
                        }
                        .distance {
                            font-size: 24px;
                            color: #999;
                        }
                        .address {
                            font-size: 24px;
                            color: #999;
                            margin-top: 5px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            margin-top: 15px;
                        }
                    }
                    .favorite_btn {
                        width: 120px;
                        height: 120px;
                        line-height: 120px;
                        text-align: center;
                        font-size: 26px;
                        background: #d62f35;
                        color: #fff;
                        position: absolute;
                        top: 0;
                        right: -120px;
                    }
                }
                .item_wrap[data-type="0"] {
                    transform: translate3d(0, 0, 0);
                }
                .item_wrap[data-type="1"] {
                    transform: translate3d(-120px, 0, 0);
                }
            }
            .no_data {
                font-size: 24px;
                color: #999;
                width: 100%;
                height: 200px;
                background: #fff;
                border-radius: 10px;
                margin-bottom: 180px;
            }
        }
        .pb180 {
            padding-bottom: 180px !important;
        }
    }
    .dine_layer {
        width: 100%;
        background: #fff;
        position: fixed;
        bottom: 0;
        z-index: 5;
        .close {
            .close_icon {
                width: 30px;
                height: 30px;
                margin: 20px;
            }
        }
        .layer_content {
            width: 100%;
            padding: 0 40px;
            box-sizing: border-box;
            .diner_info {
                width: 100%;
                .diner_icon {
                    width: 40px;
                    height: 36px;
                    margin-right: 20px;
                }
                .diner_name {
                    font-size: 36px;
                }
                p {
                    font-size: 24px;
                    color: #999;
                    margin-top: 15px;
                }
            }
            .order_type {
                margin: 40px 0 200px 0;
                .type_item {
                    .check_icon {
                        width: 38px;
                        height: 38px;
                        margin-right: 20px;
                    }
                    span {
                        height: 36px;
                        line-height: 36px;
                        font-size: 26px;
                        color: #d62f35;
                    }
                }
            }
            .dine_type {
                padding-bottom: 100px;
                h3 {
                    font-size: 26px;
                    height: 36px;
                    line-height: 36px;
                }
                .dine_items {
                    width: 100%;
                    .type_img {
                        width: 320px;
                        height: 185px;
                    }
                }
            }
        }
    }
    .diner_layer-enter {
        transform: translateY(960px);
    }
    .diner_layer-enter-active {
        transition: all 0.5s;
    }
    .shade {
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        background: rgba($color: #000000, $alpha: 0.5);
        z-index: 4;
    }
}
.mint-msgbox-wrapper {
    .mint-msgbox {
        font-size: 28px !important;
        border-radius: 10px;
        .mint-msgbox-header {
            padding-top: 30px;
            .mint-msgbox-title {
                font-size: 30px !important;
            }
        }
        .mint-msgbox-content {
            padding: 30px;
        }
        .mint-msgbox-btns {
            height: 70px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/kfc/kfcSelectDiner.vue